import { createSelector } from 'reselect';
import expandedModules from './expandedModules';

export default createSelector(expandedModules, (modules) =>
    modules.filter((item) => item.completedPercentage > 0 || item.hasCertificate),
);
